import script from "./ForgetPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgetPassword.vue?vue&type=script&setup=true&lang=js"

import "./ForgetPassword.vue?vue&type=style&index=0&id=15d45008&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15d45008"]])

export default __exports__